import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";

function PublicView() {
  const { token } = useParams();

  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setNotFound(false);

      try {
const docRef = doc(db, "publicProfiles", token);
const docSnap = await getDoc(docRef);

if (docSnap.exists()) {
  setInfo(docSnap.data());
} else {
  setInfo(null);
  setNotFound(true);
}
      } catch (error) {
        console.error("Error fetching doc:", error);
        setInfo(null);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [token]);

  if (loading) {
    return (
      <div className="portal-page">
        <img
          src={`${process.env.PUBLIC_URL}/pink-collective-logo.png`}
          alt="The Pink Collective logo"
          className="portal-logo"
        />

        <div className="portal-card portal-card-centered">
          <h1 className="portal-title">Loading</h1>
          <div className="portal-underline" />
          <p className="portal-text">Loading family info...</p>
        </div>
      </div>
    );
  }

  if (notFound) {
    return (
      <div className="portal-page">
        <img
          src={`${process.env.PUBLIC_URL}/pink-collective-logo.png`}
          alt="The Pink Collective logo"
          className="portal-logo"
        />

        <div className="portal-card portal-card-centered">
          <h1 className="portal-title">No Family Info Found</h1>
          <div className="portal-underline" />
          <p className="portal-text">
            This QR code does not match an active family profile.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="portal-page">
      <img
        src={`${process.env.PUBLIC_URL}/pink-collective-logo.png`}
        alt="The Pink Collective logo"
        className="portal-logo"
      />

      <div className="portal-card">
        <h1 className="portal-title">Family Contact Info</h1>
        <div className="portal-underline" />

        <div className="portal-info-list">
          <p className="portal-info-item">
            <strong>Child Name:</strong> {info.childName || "Not provided"}
          </p>
          <p className="portal-info-item">
            <strong>Parent Name:</strong>{" "}
            {info.name || info.parentName || "Not provided"}
          </p>
          <p className="portal-info-item">
            <strong>Parent Phone:</strong>{" "}
            {info.phone || info.parentPhone || "Not provided"}
          </p>
          <p className="portal-info-item">
            <strong>Parent Email:</strong>{" "}
            {info.email || info.parentEmail || "Not provided"}
          </p>
        </div>
      </div>
    </div>
  );
}

export default PublicView;